'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductCard = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _verify = require('helpers/verify');

var _CmsModules = require('containers/CmsPage/CmsModules');

var _CmsHeading = require('components/CmsPage/modules/CmsHeading/CmsHeading');

var _CmsText = require('components/CmsPage/modules/CmsText/CmsText');

var _Section = require('components/Section/Section');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductCard = exports.ProductCard = function ProductCard(_ref) {
  var callout = _ref.callout,
      calloutNote = _ref.calloutNote,
      cmsModuleId = _ref.cmsModuleId,
      cta = _ref.cta,
      details = _ref.details,
      modules = _ref.modules,
      tag = _ref.tag;
  return _react2.default.createElement(
    'div',
    { className: 'card' },
    _react2.default.createElement(
      _Section.Section,
      { className: 'ProductCard' },
      tag && _react2.default.createElement(
        'div',
        { className: 'ProductCard__tag' },
        _react2.default.createElement(
          'span',
          null,
          tag
        )
      ),
      _react2.default.createElement(
        'header',
        { className: 'ProductCard__callout' },
        _react2.default.createElement(_CmsHeading.HeadingTag, { className: 'ProductCard__callout-value', title: callout }),
        _react2.default.createElement(_CmsText.CmsText, {
          className: 'ProductCard__callout-unit',
          cmsModuleId: 'ProductCard:Note:' + cmsModuleId,
          content: calloutNote
        })
      ),
      (0, _verify.isEmpty)(modules) && details && _react2.default.createElement(
        'div',
        { className: 'ProductCard__content' },
        _react2.default.createElement(_CmsText.CmsText, {
          cmsModuleId: 'ProductCard:Details:' + cmsModuleId,
          content: details,
          size: 'medium'
        })
      ),
      !(0, _verify.isEmpty)(modules) && _react2.default.createElement(
        'div',
        { className: 'ProductCard__content' },
        _react2.default.createElement(_CmsModules.CmsModules, { modules: modules })
      ),
      cta && _react2.default.createElement(
        'div',
        { className: 'ProductCard__cta' },
        cta
      )
    )
  );
};

ProductCard.propTypes = {
  callout: _propTypes2.default.string,
  calloutNote: _propTypes2.default.node,
  cmsModuleId: _propTypes2.default.string.isRequired,
  cta: _propTypes2.default.node,
  details: _propTypes2.default.node,
  modules: _propTypes2.default.arrayOf(_CmsModules.CmsModuleShape),
  tag: _propTypes2.default.node
};